import { ServiceProvider } from ".";
import { clickMouseOnCanvas, doubleClickedOnCanvas, mouseDragged, mouseMoved, mouseWheel, onCanvas, pressMouseOnCanvas, releaseMouseOnCanvas } from "../shared/mouseFunctions";
import { windowResized } from "../shared/utils";
import { keyPressed, registerSpacebarListeners } from "./keyFunctions";

const s = (p) => {
    let provider;

    p.setup = () => {
        provider = new ServiceProvider(p);
        provider.canvas = p.createCanvas(p.windowWidth, p.windowHeight - 7)
            .mouseReleased(releaseMouseOnCanvas(provider))
            .mouseClicked(clickMouseOnCanvas(provider))
            .mousePressed(pressMouseOnCanvas(provider))
            .doubleClicked(doubleClickedOnCanvas(provider));

        provider.init();

        registerSpacebarListeners(provider);
    };

    p.draw = () => {
        p.background(provider.backgroundColor);

        if (provider.settings.showImage
            && provider.image
            && provider.image.loaded
        ) {
            p.push();
            p.translate(provider.view.posX, provider.view.posY);
            provider.image.display();
            p.pop();
        }

        provider.grid.display();

        p.push();
        p.translate(provider.view.posX, provider.view.posY);

        provider.elements.display();
        provider.tools.currentTool.display();

        p.pop();

        provider.speciesInfo.display();
        provider.tips.display();
        provider.sideBar.display();
        provider.grid.displayLegend();
        provider.spinner.display();

        // Debug
        // p.fill(255);
        // p.stroke(0);
        // p.rect(10, p.height - 150, 200, 140);
        // p.fill(0);
        // p.textSize(15);
        // p.noStroke();
        // p.textAlign(p.LEFT, p.TOP);
        // Object.values(provider.debug).map((value, index) => {
        //     p.text(value, 20, p.height - 145 + index * 18);
        // });
    };

    p.windowResized = () => {
        windowResized(provider);
    }

    p.mouseDragged = (event) => {
        if (onCanvas(provider)) {
            mouseDragged(event, provider);
        }
    }

    p.mouseMoved = () => {
        mouseMoved(provider);
    }

    p.mouseWheel = (event) => {
        mouseWheel(event, provider);
    }

    p.keyPressed = (event) => {
        keyPressed(provider, event);
    }
};
let planSketch = new p5(s, 'p5canvas');

export { s, planSketch };
